/** @format */
import { css } from 'styled-components';

import { theme } from '@toucan/config/theme';

import { StyledModelCardProps } from './types';

const baseStyles = ({ modelCardBreakpointsState }: StyledModelCardProps) => {
    return css`
        height: 100%;
        position: relative;

        .content-container {
            z-index: 1;
            width: 100%;
            height: 100%;
            display: grid;
            grid-template-areas:
                'thumbnail thumbnail thumbnail'
                '. . .'
                'title title button'
                'price . button';
            grid-template-columns: auto var(--layout-spacing-12) min-content;
            grid-template-rows: min-content var(--layout-spacing-8) min-content auto;

            ${modelCardBreakpointsState.small &&
            css`
                grid-template-areas:
                    'thumbnail . title . button'
                    'thumbnail . price . button';
                grid-template-columns:
                    min-content
                    var(--layout-spacing-24)
                    auto
                    var(--layout-spacing-24)
                    min-content;
                grid-template-rows: auto auto;
            `}

            ${modelCardBreakpointsState.medium &&
            css`
                grid-template-areas:
                    'thumbnail . title . description . button'
                    'thumbnail . price . description . button';
                grid-template-columns:
                    min-content
                    var(--layout-spacing-24)
                    20rem
                    var(--layout-spacing-48)
                    auto
                    var(--layout-spacing-24)
                    min-content;
                grid-template-rows: auto auto;
            `}
        }

        .expanding-card-background {
            height: 100%;
        }

        .thumbnail {
            grid-area: thumbnail;
            align-self: center;
            justify-self: center;
        }

        .title {
            grid-area: title;
            height: min-content;
            align-self: flex-end;
        }

        .price {
            ${theme.typography.body_small}
            grid-area: price;
            width: 100%;
            align-self: flex-end;

            ${modelCardBreakpointsState.small &&
            css`
                align-self: flex-start;
            `}
        }

        .description {
            grid-area: description;
            width: 100%;
            display: none;
            align-self: center;

            ${modelCardBreakpointsState.medium &&
            css`
                display: -webkit-box;
            `};
        }

        .button {
            grid-area: button;
            align-self: flex-end;

            ${modelCardBreakpointsState.small &&
            css`
                align-self: center;
            `}
        }
    `;
};

const outOfStockStyles = ({ isOutOfStock }: StyledModelCardProps) => {
    if (!isOutOfStock) return;

    return css`
        .thumbnail {
            opacity: 0.5;
        }
    `;
};

export const styles = (props: StyledModelCardProps) => css`
    ${baseStyles(props)}
    ${outOfStockStyles(props)}
`;
